@if (canShow) {
<reviews-io-carousel class="block p-t-10 p-b-10 p-t-12-s p-b-8-s p-t-12-m p-b-8-m"
                     id="reviews"
                     [product]="product"></reviews-io-carousel>
}